/**
 * LoadSEER Integration Constants
 * Named constants to avoid magic numbers throughout the codebase
 */

// ============================================================================
// Selection Limits
// ============================================================================

/**
 * Maximum number of nodes that can be selected simultaneously
 * Prevents UI/performance issues from loading too many datasets at once
 */
export const MAX_NODE_SELECTIONS = 20;

// ============================================================================
// API Configuration
// ============================================================================

/**
 * Default timeout for API requests in milliseconds (30 seconds)
 * Prevents indefinite waiting on slow/failed API responses
 */
export const API_REQUEST_TIMEOUT_MS = 30_000;

/**
 * Default page size for paginated API responses
 */
export const DEFAULT_PAGE_SIZE = 100;

/**
 * Maximum number of pages to fetch when retrieving all descendants
 * Prevents infinite loops and excessive API calls
 */
export const MAX_DESCENDANT_PAGES = 100;
